/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActivateTicketRequestApiFrom } from '../../models/activate-ticket-request-api-from';

export interface ApiV3ServiceActivateTicketPost$Params {

/**
 * Interface language
 */
  lang?: string;
      body?: ActivateTicketRequestApiFrom
}

export function apiV3ServiceActivateTicketPost(http: HttpClient, rootUrl: string, params?: ApiV3ServiceActivateTicketPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceActivateTicketPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiV3ServiceActivateTicketPost.PATH = '/api/v3/service/ActivateTicket';
